<template>
    <main>
      <div
        class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
      >
        <div @click.prevent="$emit('close-sidebar')" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
        <h2 class="heading-text">Business Documents</h2>
      </div>
        <div class="grid mb-10 bg-white rounded-xl overflow-hidden mx-4">
          <div
            class="flex justify-between border-b items-center px-4 py-5"
            :class="docType.status?.toLowerCase() === 'verified' ? '' : 'cursor-pointer'"
            v-for="(docType, index) in documentTypes"
            :key="index"
            @click.prevent="docType.status?.toLowerCase() !== 'verified' ? selectDocument(docType) : undefined"
          >
            <div class="flex justify-between w-full" v-if="docType.status?.toLowerCase() === 'verified'">
              <p class="label-text-normal font-bold">{{ docType.name }}</p>
              <p class="secondary-heading-text-blogger font-semibold capitalize text-successColor">
                {{ docType.status }}
              </p>
            </div>
              <span v-else class="label-text-normal">{{ docType.name }}</span>
          </div>
        </div>
      <!-- Password Protected Section -->
      <router-view>
        <sidebar
          :isPanelOpen="isPanelOpen"
          @closeSidebarPanel="false"
          position="bottom"
          paddingTopBottom="paddingTopBottomHide"
          :panelHeight="customPanelHeight"
        >
          <section
            class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-2 pt-4"
          >
            <div @submit="false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
            <h2 class="heading-text">Business Document</h2>
          </section>
          <div class="grid gap-4">
            <form @submit.prevent="pdfPasswordFun()">
              <section class="grid gap-6 px-4 py-4">
                  <article class="flex justify-between pr-4 h-16 items-center rounded-lg shadow-cardShadow w-full bg-white">
                    <div class="flex items-center">
                      <div class="w-16 h-16">
                        <Vue3Lottie :animationData="AutoTick" :speed="1" :loop="true" />
                      </div>
                      <span>
                        <p class="label-text-medium whitespace-nowrap truncate w-32">{{ storagePdf?.name }}</p>
                        <p class="secondary-heading-text-blogger">File Uploaded</p>
                      </span>
                    </div>
                    <div>
                      <p @click.prevent="removePdf()" class="underline font-blogger text-xs text-primary font-semibold cursor-pointer">
                        Remove
                      </p>
                    </div>
                  </article>
                  <article class="grid gap-2">
                      <p class="label-text-medium">Password</p>
                      <input
                        type="text"
                        name="password"
                        id="password"
                        class="input rounded-lg shadow-cardShadow"
                        placeholder="Enter Password"
                        v-model="pdfPasswordValue"
                        required
                      />
                      <p class="secondary-heading-text">
                          This PDF is password-protected. Please enter the password below to upload and continue.
                      </p>
                  </article>
              </section>
              <section class="grid py-8 px-4">
                <custom-button
                  type="submit"
                  variant="primary"
                  arrowAnimation
                >
                  Submit
                </custom-button>
              </section>
            </form>
          </div>
        </sidebar>
      </router-view>
      <!-- Spin Loader -->
      <spin-loader :spinLoading="isSpinLoading"/>
    </main>
</template>
<script>
import { mapGetters } from 'vuex';
import SpinLoader from './spinLoader.vue';
import Sidebar from './Sidebar.vue';
  import CustomButton from './CustomButton.vue';
  import AutoTick from '../assets/animation/auto-tick.json';

export default {
  name: 'Business Documents List',
  components: {
    CustomButton,
    SpinLoader,
    Sidebar
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      'applicationSummary',
      'applicationId',
      'flagsData',
      'udyamDataPass',
      'gstDataQuery',
      'fssaiDataPass',
      'fdaDataPass',
      'shopAndEstablishmentDataPass',
      'otherDataPass'
    ]),
  },
  props: {
    businessDocumentSelectProps: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      AutoTick,
      selectedDocument: null,
      customPanelHeight: 'auto',
      isSpinLoading: undefined,
      docSubType: undefined,
      isPanelOpen: false,
      storagePdf: undefined,
      pdfPasswordValue: undefined,
      documentTypes: [
        { name: "GSTIN", status: undefined },
        { name: 'Udyam Certificate', status: undefined },
        { name: "FSSAI", status: undefined },
        { name: "FDA", status: undefined },
        { name: "Shop & Establishment", status: undefined },
        { name: "Others", status: undefined }
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const summaryData = this.applicationSummary;
      const documentConfigs = [
        {
          condition: summaryData?.businessInfo?.udyamDetails || this.udyamDataPass,
          label: 'Udyam Certificate',
          blockArg: true
        },
        {
          condition: summaryData?.businessInfo?.gstin || this.gstDataQuery?.length > 0,
          label: 'GSTIN',
          blockArg: true
        },
        {
          condition: summaryData?.documentListUploaded?.fssaiUploaded || this.fssaiDataPass,
          label: 'FSSAI'
        },
        {
          condition: summaryData?.documentListUploaded?.fdaUploaded || this.fdaDataPass,
          label: 'FDA'
        },
        {
          condition: summaryData?.documentListUploaded?.shopAndEstablishmentUploaded || this.shopAndEstablishmentDataPass,
          label: 'Shop & Establishment'
        },
        {
          condition: summaryData?.documentListUploaded?.othersUploaded || this.otherDataPass,
          label: 'Others'
        }
      ];
      documentConfigs.forEach(({ condition, label, blockArg }) => {
        if (!condition) return;
        if (blockArg) {
          this.$emit('close-sidebar');
          this.$emit('is-business-block');
        }
        this.updateDocumentStatus(label, 'verified');
      });

      if (this.businessDocumentSelectProps) {
        this.selectedDocument = this.businessDocumentSelectProps;
        this.requestMedia();
      }
    },
    selectDocument(docType) {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_DOCUMENT_MODE_SELECTED, {
        [this.$mixpanelPayload.KEY_CLICK]: docType
      });
      if (docType.name === 'GSTIN') {
        this.$router.push({
          name: 'Other Gst Add Business Verification',
        });
      } else if (docType.name === 'Udyam Certificate') {
        this.$router.push({
          name: 'Udyam Verification Add'
        });
      } else {
        this.selectedDocument = docType.name;
        this.requestMedia();
      }
    },
    requestMedia() {
      const mediaRequest = {
        allowedMimeTypes: ["image/jpeg", "application/pdf"],
      };
      window.microapps.requestMedia(mediaRequest).then(response => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: 'success',
          [this.$mixpanelPayload.KEY_MESSAGE]: 'manual upload bank statement list component',
        });
        const fileByteArray = this.base64ToByteArray(response.bytes);
        const blob = new Blob([fileByteArray], { type: response.mimeType });
        this.openFilePicker(blob);
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_REQUEST_MEDIA, {
          [this.$mixpanelPayload.RESPONSE]: err,
          [this.$mixpanelPayload.KEY_MESSAGE]: 'manual upload bank statement list component',
        });
        if (this.businessDocumentSelectProps) {
          this.$emit('close-sidebar');
        }
      });
    },
    getFileExtension(blob) {
      const splitName = blob.type.split('/');
      return splitName[splitName.length - 1];
    },
    base64ToByteArray(base64String) {
      const binaryString = window.atob(base64String);
      const byteArray = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i += 1) {
        byteArray[i] = binaryString.charCodeAt(i);
      }
      return byteArray;
    },
    async openFilePicker(blob) {
      const fileExtension = this.getFileExtension(blob);
      const timestamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\..*$/, '');
      const fileName = `business_document_${timestamp}.${fileExtension}`;
      // Create a File object multipart
      const multipartFile = new File([blob], fileName, {
        lastModified: Date.now(),
        type: blob.type,
      });
      this.storagePdf = multipartFile;
      if (blob.type === "application/pdf") {
          const locked = await this.$store.dispatch("checkPdfPasswordProtected", multipartFile);
          if (locked) {
            this.isSpinLoading = false;
            this.isPanelOpen = true;
          } else {
            this.isPanelOpen = false;
            this.setBusinessRegistrationProof(multipartFile);
          }
      } else {
        this.isPanelOpen = false;
        this.setBusinessRegistrationProof(multipartFile);
      }
    },
    setBusinessRegistrationProof(multipartFile) {
      this.isSpinLoading = true;
      const formData = new FormData();
      formData.append("file", multipartFile);
      switch (this.selectedDocument) {
        case "FSSAI":
          this.docSubType = "fssai";
          break;
        case "FDA":
          this.docSubType = "fda";
          break;
        case "Shop & Establishment":
          this.docSubType = "shop_and_establishment";
          break;
        default:
          this.docSubType = "others";
      }
      const params = {
        businessInfo: {
          registrationProof: {
            docType: "business_registration_proof",
            docSubType: this.docSubType,
          },
        },
      };
      formData.append("jsonPayload", JSON.stringify(params));
        this.$store
          .dispatch("applicationBusinessRegistrationProof", {
            formData,
            applicationId: this.applicationId,
            urlParams: {
              review: true,
            },
          })
          .then(() => {
            this.$emit('close-sidebar');
            this.$emit('is-business-block');
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_REGISTRATION_UPLOAD, {
              [this.$mixpanelPayload.RESPONSE]: 'success',
              [this.$mixpanelPayload.KEY_MESSAGE]: params,
            });
            this.$moshaToast('Document uploaded successfully.', {
              type: "success",
              showIcon: true,
            });
            if (this.selectedDocument === 'FSSAI') {
              this.$store.commit('FSSAI_DATA_PASS', true);
            } else if (this.selectedDocument === 'FDA') {
              this.$store.commit('FDA_DATA_PASS', true);
            } else if (this.selectedDocument === 'Shop & Establishment') {
              this.$store.commit('SHOP_AND_ESTABLISHMENT_DATA_PASS', true);
            } else {
              this.$store.commit('OTHER_DATA_PASS', true);
            }
            if (this.pdfPasswordValue) {
              this.closeUnlockPDoc();
            }
            this.isSpinLoading = false;
          })
          .catch((err) => {
            this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_BUSINESS_REGISTRATION_UPLOAD, {
              [this.$mixpanelPayload.ERROR_REASON]: err.message,
            });
            this.isSpinLoading = false;
          });
    },
    closeUnlockPDoc() {
      this.isPanelOpen = false;
      this.pdfPasswordValue = undefined;
      this.storagePdf = undefined;
    },
    removePdf() {
      this.isPanelOpen = false;
      this.pdfPasswordValue = undefined;
      this.storagePdf = undefined;
      this.requestMedia();
    },
    pdfPasswordFun() {
      this.isSpinLoading = true;
      this.$store.dispatch("unlockPdfWithPassword", {
        file: this.storagePdf,
        password: this.pdfPasswordValue,
      })
      .then(({ unlockedFile }) => {
        this.isSpinLoading = true;
        this.setBusinessRegistrationProof(unlockedFile);
      })
      .catch((err) => {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_PASSWORD_PDF_ERROR, {
          [this.$mixpanelPayload.RESPONSE]: err,
          [this.$mixpanelPayload.KEY_MESSAGE]: 'Password protected PDF error in bank statement upload',
        });
        this.isSpinLoading = false;
        this.$moshaToast(err.message, {
          type: "danger",
          showIcon: true,
        });
      });
    },
    updateDocumentStatus(docName, status) {
      this.documentTypes = this.documentTypes.map(doc =>
          doc.name === docName ? { ...doc, status } : doc
      );
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
